var map = {
	"./1.jpg": 1394,
	"./2.jpg": 2557,
	"./3.jpg": 306,
	"./4.jpg": 5273,
	"./5.jpg": 9468,
	"./photo_2023-10-18_14-45-50.jpg": 3031,
	"./photo_2023-10-18_14-45-59.jpg": 8560,
	"./photo_2023-10-18_14-46-00.jpg": 6381,
	"./photo_2023-10-18_14-46-01.jpg": 8490,
	"./photo_2023-10-18_14-46-02.jpg": 7011,
	"./photo_2023-10-18_14-46-03.jpg": 6582
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1831;